<template>
    <div class="lms__superadmin_auditlog_list">
        <div class="lms__superadmin_auditlog_list_header">
            <view-actions
                :title="'Audit log'"
                :cancel-button-active="false"
                :submit-button-active="false"
            />
        </div>
        <div class="lms__superadmin_auditlog_list_main">
            <component-list
                :component-table="LmsSuperadminAuditLogListTable"
                :component-table-name="'audit log'"
                :filter-search-active="false"
                :filter-select-active="true"
                :filter-search-queryable="true"
                :filter-select-prefix="''"
                :filter-select-items="filtersSelect"
                :get-pagination-getter="!user.isSuperadmin() && !user.hasSelectedProfile() ? 'getLmsSuperadminAuditLogPagination' : ''"
                :get-items-getter="!user.isSuperadmin() && !user.hasSelectedProfile() ? 'getLmsSuperadminAuditLogData' : ''"
                :get-items-dispatch="!user.isSuperadmin() && !user.hasSelectedProfile() ? 'lmsSuperadminAuditLogGet' : ''"
                :get-items-dispatch-trigger-name="'trigger-get-auditlog'"
                :empty-state-title="!user.isSuperadmin() && !user.hasSelectedProfile() ? 'Please select workspace first' : 'No results'"
                :empty-state-button-active="true"
                :empty-state-button-text="'Go to workspaces'"
                :item-name="['audit log', 'audit logs']"
                :table-preferences-active="true"
                @emit-empty-state-submit="redirectToUserWorkspaces"
            />
        </div>
    </div>
</template>

<script>
import LmsSuperadminAuditLogListTable from '@/components/lms/superadmin/audit-log/list/LmsSuperadminAuditLogListTable'
import ViewActions from '@/components/default/shared/ViewActions'
import ComponentList from '@/components/default/shared/ComponentList'
import { User } from '@/User'
import ComponentNote from '@/components/default/shared/ComponentNote'
import ComponentButton from '@/components/default/shared/ComponentButton'

export default {
  name: 'lms-superadmin-audit-log-list',
  components: { ComponentButton, ComponentNote, ComponentList, ViewActions },
  data () {
    return {
      LmsSuperadminAuditLogListTable,
      user: new User()
    }
  },
  computed: {
    filtersSelect () {
      let filtersArr = []

      if (this.user.isSuperadmin() && !this.user.hasSelectedProfile()) {
        filtersArr.push({
          key: 'customer',
          label: 'Customers',
          type: 'multiselect',
          getItemsGetter: 'getLmsSuperadminCustomersMappedIdNameStatus',
          getItemsGetterMapped: 'getLmsSuperadminCustomersMappedLabelValue',
          getItemsDispatch: 'lmsSuperadminCustomersGet',
          getPaginationGetter: 'getLmsSuperadminCustomersPagination',
          itemName: ['customer', 'customers'],
          searchQueryable: true,
          tableLabels: [
            {
              key: 'name',
              title: 'Name',
              type: 'string',
              sortable: true,
              queryable: true
            }
          ]
        })
      }
      filtersArr.push({
        key: 'workspace',
        label: 'Workspace',
        type: 'multiselect',
        getItemsGetter: 'getLmsSuperadminWorkspacesMappedIdNameStatus',
        getItemsGetterMapped: 'getLmsSuperadminWorkspacesMappedLabelValue',
        getItemsDispatch: 'lmsSuperadminWorkspacesGet',
        getPaginationGetter: 'getLmsSuperadminWorkspacesPagination',
        itemName: ['workspace', 'workspaces'],
        searchQueryable: true,
        tableLabels: [
          {
            key: 'name',
            title: 'Name',
            type: 'string',
            sortable: true,
            queryable: true
          },
          {
            key: 'customer',
            title: 'Customer',
            type: 'string'
          }
        ]
      })
      filtersArr.push({
        key: 'type',
        label: 'Type',
        type: 'checkbox',
        values: [
          {
            label: 'User management',
            value: 'userManagement'
          },
          {
            label: 'API service management',
            value: 'apiServiceManagement'
          },
          {
            label: 'Organisation structure management',
            value: 'organisationStructureManagement'
          }
        ]
      })
      filtersArr.push({
        key: 'dates',
        label: 'Dates range',
        type: 'date'
      })

      return filtersArr
    }
  },
  methods: {
    createAuditLog () {
      this.$router.push({ name: 'lms-superadmin-audit-log-add' })
    },
    redirectToUserWorkspaces () {
      this.$router.push({ name: 'lms-user-workspace-list' })
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/lms/superadmin/audit-log/_lmssuperadminauditloglist.scss";
</style>
